import React from 'react'

import { Footer } from './Footer'
import { FullPageTemplate, FullPageTemplateProps } from './FullPageTemplate'

export type FullPageProps = Omit<FullPageTemplateProps, 'footer'>

export const FullPage = (props: FullPageProps) => (
  <FullPageTemplate {...props} footer={<Footer />} />
)
